import { merge } from "lodash";
import { FeatureRole, RemoteGatewayType, Seller, SellerMeta } from "types";

const stripeGatewayTypes = [
    RemoteGatewayType.STRIPE_XOLA,
    RemoteGatewayType.STRIPE_XOLA_CANADA,
    RemoteGatewayType.STRIPE_OAUTH,
    RemoteGatewayType.STRIPE_API_KEY,
];

export const isStripeEnabled = (seller?: Seller) => {
    const gatewayType = seller?.defaultGateway?.type;
    if (gatewayType) {
        return stripeGatewayTypes.includes(gatewayType);
    }

    return false;
};

const authorizeNetGatewayTypes = [RemoteGatewayType.AUTHORIZE_NET_AIM, RemoteGatewayType.AUTHORIZE_NET_CIM];

export const isAuthorizeNetEnabled = (seller?: Seller) => {
    const gatewayType = seller?.defaultGateway?.type;
    if (gatewayType) {
        return authorizeNetGatewayTypes.includes(gatewayType);
    }

    return false;
};

export const getMeta = (seller: Seller): SellerMeta => {
    return merge(
        {},
        {
            features: {
                pos: {
                    // Get all codes from http://keyhut.com/popopen4.htm
                    // Also see the wiki for printer troubleshooting and compatibility https://xola01.atlassian.net/wiki/spaces/PROD/pages/4128835/Printer+Compatibility
                    paperCutCode: "x1Bx64",
                    drawerEjectCode: "x07",
                    html: {
                        paddingLeft: 0.2,
                        paddingRight: 0.1,
                        paddingBottom: 1,
                    },
                },
            },
        },
        seller.meta,
    );
};

export const isPurchaseEmailRequired = (seller: Seller): boolean => {
    return getMeta(seller)?.["xola/seller/make_order/email_required"] ?? true;
};

export const isPurchasePhoneRequired = (seller: Seller): boolean => {
    return getMeta(seller)?.["xola/seller/make_order/phone_required"] ?? true;
};

export const shouldAutoExpandRosterNotes = (seller: Seller) => {
    if ("xola/seller/roster/autoExpandNotes" in seller.meta) {
        return seller.meta["xola/seller/roster/autoExpandNotes"];
    }

    return true;
};

export const getSellerLocale = (seller: Seller) => {
    return seller.preferences.language.locale?.replaceAll("-", "_") ?? "en_US";
};

export const hasDistributionProfileConfigured = (seller: Seller) => {
    return seller.preferences.network?.enabled ?? false;
};

export const isCrossAccountSellingEnabled = (seller: Seller) => {
    return seller.roles.includes(FeatureRole.CROSS_ACCOUNT_SELLING);
};

export const getSellerPublicEmail = (seller: Seller) => {
    return seller.communicationEmail ?? seller.email;
};
